/**
 * The duration of the day in milliseconds.
 */
/**
 * The duration of the day in milliseconds.
 */ export var MS_PER_DAY = 86400000;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-date-math/dist/es/ms-per-day.js
// module id = ../../../../@progress/kendo-date-math/dist/es/ms-per-day.js
// module chunks = 3